import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stats",
  "use": "icon-stats-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stats\"><defs><style type=\"text/css\"></style></defs><path d=\"M478.723413 502.244693L189.812053 233.970347c-61.282987 72.861013-98.205013 166.89152-98.205013 269.550933 0 91.521707 29.34784 176.186027 79.141547 245.108053l307.974826-246.38464zM218.371413 203.257173l271.32928 251.948374V85.03296c-105.366187 5.178027-200.4992 49.27488-271.32928 118.224213z m313.27232-118.217386v428.58496l-334.677333 267.73504c76.762453 86.596267 188.829013 141.165227 313.644373 141.165226 231.410347 0 419.007147-187.593387 419.007147-419.00032 0-224.3584-176.336213-407.528107-397.974187-418.484906z\" p-id=\"986\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/stats.svg
// module id = uUq3
// module chunks = 6